import React from 'react'
import './blogs.css'
const Rahul_Gauriyar = () => {
    return (
        <div className='blog'>
            <div className='container-fluid'>
                <div className='row blog-row'>
                    <div className='col-md-4'>
                        <img src='placement-postulates/dp/Rahul-Gauriyar.jpg' className='blog-dp' alt='aryaman'></img>
                    </div>
                    <div className='col-md-8'>
                        <div className='blog-head'>
                            <h2>Rahul Gauriyar</h2>
                            <small>Software Engineer at JioSaavn</small>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div>
    <p>
      As the memorable journey in college approaches a close, it's time for the most momentous event in the
      path for most of us, the placements. Extreme emotions, tough situations, and whatnot.</p>
      <img class="blog-image-left" src="placement-postulates/blogs/Rahul-Gauriyar/1.jpg"/>
    <p>
      Hello Everyone, I am Rahul Gauriyar, Y16 BT-MT Dual Degree student, placed in JioSaavn as Software
      Engineer
      this year. I spent the first two years in a carefree, casual manner relishing every moment, getting high
      on
      TV series and night outs with wingies, taking joy in extracurricular activities and hence remained
      apathetic
      towards academics. My CPI suffered but realization struck gradually and I was able to secure a Data
      Science
      internship in the internship season in my 3rd year, only to miss it later for some reason. Meanwhile, I
      was
      also getting inclined towards research and wanted to try my hands in it too and so I applied for a Dual
      Degree.
    </p>
    <p>
      The trip home in the 2019-20 second semester mid-sem break was a deceptive one. I, even in my wildest
      dreams, hadn’t imagined it is the last time me and my wingies are having fun together in college. The
      recess
      extended and as the situation unfolded, it became clear we are not returning to the institute any time
      soon.
      This is when I decided to kickstart my placement preparation. There are a handful of roles for which
      various
      companies recruit, Software development, AI & ML roles, Consulting, Analytics, Finance(very few firms)
      and
      Departmental core(very few in other branches except CSE and EE). I mostly targeted Software and AI firms
      as
      I realised my interest was inflated in these roles and my chances bleak in others. Do not try to place
      your
      foot in every boat, rather shortlist 1 or 2 roles and dedicate your time to them.
    </p><img class="blog-image-right" src="placement-postulates/blogs/Rahul-Gauriyar/2.jpg"/>
    <p>
      Meanwhile, I was also looking for some internship opportunities in the ML role and my search landed me a
      Computer Vision Intern in Campus Haat. The placement sessions by the SPO had also started and it was the
      time to show all your knowledge, skills and talents on a piece of paper, resume. I had made only one
      resume
      since I wasn’t looking towards Consulting or core firms. I focused on including every aspect, academic
      as
      well as social, ranging from internship and projects to some decent PORs. My focus was to keep the
      resume
      more holistic rather than disproportionate in one aspect or the other.
    </p>
    <p>
      For the resume, avoid including things on which you do not have command. Slight exaggeration is fine,
      given
      that you prepare that part before any actual interview, but excessive use of it will only lead you to
      trouble. And if the interviewer realises your knowledge is negligent on something mentioned in your
      resume,
      consider your chances minuscule. So it's important to mention projects you have worked on, skills and
      tools
      you know about. Always get your resume verified and filtered through some seniors before submitting it
      to
      SPO. <br/>
      With the resume submission, SPO inaugurated the placement season for the year and a hectic online
      semester
      with projects and weekly quizzes had begun. Though it was less stressful for me than 4th yearites(me
      being
      in 5th year), the coding practice, the overjoying of correct submission and anguish of failed test cases
      and
      the fast-approaching placement tests enhanced the pressure.
    </p><img class="blog-image-left" src="placement-postulates/blogs/Rahul-Gauriyar/3.jpg"/>
    <p>
      Meanwhile, I tried to keep my preparation sources as concise as possible. There are a lot of other
      things
      apart from role specifics you need to prepare; your courses being one of them. For coding prep, I solved
      every interviewbit question once, then proceeded to solve most liked and medium level and few hard
      leetcode
      questions. After I have exhausted both, I looked over to <a href="https://www.geeksforgeeks.org/must-do-coding-questions-for-companies-like-amazon-microsoft-adobe/" class="links">Must Do Coding Questions on GeeksforGeeks</a> . It was September
      end and I thought my
      coding preparation was up to the mark, only to realise later I was living in fool’s paradise. Few
      companies
      started their coding tests and I started lagging in questions. It is then I perceived that solving
      questions
      over time doesn’t help much but the panache to solve them quickly is the key, the skill which
      competitive
      coders acquire over 2-3 years. Now since I didn’t have the time to sharpen my ability up to that level,
      I
      decided to go through every question I had solved in the last six months once again; only to refresh my
      visual memory. Thus, I would like to suggest to anyone who has less time left and wants to prepare for
      Software roles; go through standard problems once(maybe 250 in number), revise them, and still if you
      have
      time left, revise them again. It's better to remember a few things you have studied, rather than
      studying a
      mountain of resources, only to forget them later. Also try to remember all the standard algorithms in
      every
      topic(Graphs, DP, Greedy, Tree, etc) so that you can reproduce them quickly when needed. Most questions
      in
      tests are an extension of standard algorithms only.
    </p><img class="blog-image-right" src="placement-postulates/blogs/Rahul-Gauriyar/4.jpg"/>
    <p>
      I had severely undermined the importance of aptitude, thought all our life we have played with numbers,
      how
      dare a simple profit loss or percentage question could scare us. Just in a talk with a senior, he
      explained
      how aptitude won’t come to scare me, it will come to haunt me. He advised me to memorize some important
      formulae and not attempt to solve every question from scratch as it would take too much time. I
      hurriedly
      went through some <a href="https://www.prepleaf.com/" class="links">Prepleaf</a> and <a href="https://www.pariksha.co/placements" class="links">Pariksha</a> tests and resources.
    </p>
    <p>
      By mid-Oct, tests were in full swing, with most of the evening already booked with pre-placement talks
      and
      tests in the late evening or night. Though few companies might not open some roles for us like Flipkart
      Data
      Scientist or Graviton Research etc or some other department specific roles, there will be ample
      opportunities available if you clear a certain CPI threshold(7 or 7.5 in most cases). So be prepared to
      devote most of your post evening to late-night time to placement-related activities; given this, you
      must
      finish your revision of courses and projects much early. Few courses are of utmost importance like Data
      Structures and Algorithms and Probability and Statistics. If you haven’t enrolled in DSA in college, no
      worries, just do any popular and exhaustive online one. If you are reading this piece in your 2nd and
      3rd
      year and your target is the Coding profile, I’ll say it doesn’t matter whether you get DSA during
      pre-registration or not, just audit it; I bet you won’t regret it. The same is with Machine Learning,
      there
      are plenty of resources online, the most famous <a
        href="https://www.coursera.org/learn/machine-learning?utm_source=gg&utm_medium=sem&utm_campaign=07-StanfordML-IN&utm_content=07-StanfordML-IN&campaignid=1950458127&adgroupid=71501032500&device=c&keyword=machine%20learning%20course%20on%20coursera&matchtype=e&network=g&devicemodel=&adpostion=&creativeid=351294671923&hide_mobile_promo&gclid=CjwKCAjwtpGGBhBJEiwAyRZX2mgE9KSFqaWTnDgemA2dJrWoxz_lKeQXXrOkG7Jk6XTT8V_tZOJ8ZBoCla8QAvD_BwE"
        class="links">Andrew Ng's Coursera</a> and <a href="https://www.udemy.com/course/machinelearning/" class="links">Machine Learning A-Z</a> are good to start, then slowly progress to more comprehensive
      and
      detailed courses. These basic courses are good for understanding and intuition; so make sure you cover
      more
      mathematical ones too as some companies might make you delve deep into the maths part of it. I preferred
      to
      go through <a href="https://youtube.com/playlist?list=PLoROMvodv4rMiGQp3WXShtMGgzqpfVfbU" class="links">Stanford CS229</a> (Andrew Ng’s Stanford Course) and briefly read <a href="https://www.cs.cornell.edu/courses/cs4780/2019fa/"
        class="links">Cornell CS4780</a> for
      mathematical understanding. I was fortunate that an ML course was being offered in our department
      (probably
      for the first time) in that semester. It helped me a lot to keep track of the topic. Try to do some good
      projects in ML; refer to Kaggle, as some hands-on experience is necessary to gain a deeper
      understanding.
    </p><img class="blog-image-left" src="placement-postulates/blogs/Rahul-Gauriyar/5.jpg"/>
    <p>
      Finally, the day arrived, December 1, the red letter day, the day for which everyone has borne so much
      pressure and remained on tenterhooks for so many nights. This time, the interview schedule was a
      different
      one, online and starting at midnight. I had two interviews on Day 1, Finmechanics and Flipkart ABA.
      Finmechanics was scheduled in the early morning, Slot 1. Though unrelated, out of complete anxiety and
      feeling of unpreparedness, I foolishly called one of my friends, working in Morgan Stanley, to seek
      advice
      on any simple finance-related concepts, only because the name of the company sounded so. Instead, he
      calmed
      me down and boosted my morale. Friends and family are really important during interviews. Just talk to
      them,
      whenever you feel low. Find a friend with whom you can talk at any moment about anything. Well, my
      interview
      in Finmechanics went for 20 minutes. I was asked about my projects, internship, <a href="https://www.geeksforgeeks.org/puzzle-21-3-ants-and-triangle/" class="links">3 Ants and
        Triangle
        puzzle</a> and comparison of different sorting algorithms. I thought my interview went quite well; I
      didn’t stumble on any questions but I wasn’t called for the second round. In the afternoon, I had
      Flipkart
      ABA. The interviewer was friendly but according to me, my interview was quite a disaster. I fumbled
      various
      questions, approached a case study very vaguely. I knew I was done for the day. The following day I had
      Hilabs scheduled, a proper AI firm. Though sleep-deprived, I started reading abstract ML topics in the
      night
      only with the fear of missing out on anything. The next day I featured in the JioSaavn and Vmock
      shortlist
      and Navi Technologies extended shortlist. It was a jam-packed evening and night. First, the Navi
      Technologies interview started at 4 pm. The interviewer asked a string manipulation and a DP question to
      be
      solved on a shared google doc. The coding questions were fairly easy but I got stuck in one of the
      theoretical questions on vector memory allocation. I wasn’t called in the second round again. In
      JioSaavn's
      first round there were two coding questions, one related to string comparison and the other a DP
      question
      similar to string transformation. The interviewer asked me to proceed to the second round where I was
      asked
      about my projects and internship and also one coding question somewhat similar to pattern searching in a
      matrix. I also went for the Hilabs, where the first round was ML and puzzle-based and the second round
      was
      Coding. In the second round, the interviewer told me he would keep elevating the question difficulty
      after I
      solve one correctly. My interview started with a quick sort, then inverting binary tree came by,
      gradually
      progressed to finding longest substring with at most k distinct characters, jumping to a DP problem (I
      don’t
      exactly remember the question) and finally a hard-linked list problem at which I got stuck in between.
      Though already scheduled I didn’t get time for the Vmock interview as it was already midnight. I was
      pretty
      sure either Hilabs or JioSaavn would be converted, I sat, feverishly anticipating the cold winter night,
      waiting for the result, literally praying to God to close my portal today. The moment came, around 3 am,
      when I saw my name in Jiosaavn's final list, it halted my prep journey, beginning a new one in life.
    </p><img class="blog-image-right" src="placement-postulates/blogs/Rahul-Gauriyar/6.jpg"/>
    <p>
      Resources and Recommendations :
    <ul>
      <li>
        Coding: <a class="links" href="https://www.interviewbit.com/">Interviewbit</a> , Medium to Hard most
        liked <a class="links" href="https://leetcode.com/problemset/all/">Leetcode problems</a>, <a class="links" href="https://www.geeksforgeeks.org/must-do-coding-questions-for-companies-like-amazon-microsoft-adobe/">Must
          to do Coding questions GFG</a>, past year archives
      </li>
      <li>
        Machine Learning: Any ML course in the institute and some projects. Otherwise any good
        beginner-level
        course followed by <a class="links" href="https://youtube.com/playlist?list=PLoROMvodv4rMiGQp3WXShtMGgzqpfVfbU">Stanford CS229</a>
        video
        lectures and <a class="links" href="https://www.cs.cornell.edu/courses/cs4780/2019fa/">Cornell
          CS4780</a> (brief reading is enough) with projects
      </li>
      <li>
        Deep Learning: <a class="links" href="http://introtodeeplearning.com/">MIT 6.S191</a> (Intro to Deep
        Learning)
      </li>
      <li>
        Aptitude: <a class="links" href="https://www.prepleaf.com/">Prepleaf</a> and <a class="links" href="https://www.pariksha.co/placements">Pariksha</a> tests
      </li>
      <li>
        Puzzles: <a class="links" href="https://brainstellar.com/">Brainstellar</a> and <a class="links" href="https://www.geeksforgeeks.org/category/puzzles/">GFG Puzzles</a>(Most are repetitive and
        similar, so it won’t take much time)
      </li>
      <li>
        Any internship whether through spo or off-campus is good, given your nature and quality of work is
        up to
        the mark. But make sure you have at least one internship in your resume as it gives you an edge and
        may
        serve as shortlisting criteria for some companies. Apply on LinkedIn, contact relevant seniors in
        your
        field of choice.
      </li>
      <li>
        Try to keep your placement semester as light as possible as the time needed for placement related
        activities will soar up quickly in the latter half after mid sem recess
      </li>
      <li>
        Revise your resume as many times as you can. Think about what the interviewer might ask you and
        prepare
        the answers accordingly. Give mock interviews with friends and seniors who are already in the
        industry.
      </li>
      <li>
        Also, focus on nonacademic elements in your resume like PORs, etc, and try to conduct 1-2 interviews
        with friends on it. People generally prepare the academic part well but ignore the extra-curricular.
      </li>
      <li>
        Highlight major and strong points in your resume and during the interview emphasize those points,
        they
        could be game-changers
      </li>
      <li>
        Pressure starts building from 15 days before the interview; missing shortlists might make you
        falter,
        but stay motivated. If you are prepared well, you will get a chance in an extended shortlist and
        walk-ins which start as early as Day 2.
      </li>
      <li>
        Go for a run if you are feeling low; I bet you will again start feeling motivated. Regularly talk
        with
        your friends. Any standup comedy or movie in a while is a treat to cheer you up.
      </li>
    </ul>
    <b>Good Luck with Placements!!!</b>
    </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Rahul_Gauriyar